<template>
    <div class="homepage d-flex flex-column vh-100">
         <!-- navbar -->
        <div class="d-flex align-items-center gap-3 p-3 bg-primary">
            <span @click="$router.go(-1)" class="text-white"><i class="bi bi-arrow-left fs-5"></i></span>
        <div>
            <h6 class="fw-bold text-white mb-0">Go Back</h6>
            <p class="text-white-50 small m-0">To Home</p>
        </div>
      </div>
         <!--start------------------------------------------------------- body----------------------------------------------------------------------------->

         <!-- Body -->
        <div class="container d-flex flex-column justify-content-center align-items-center flex-grow-1">
            <div class="card p-4 shadow" style="width: 100%; max-width: 400px;">
                <h3 class="text-center mb-3">Verify Yourself</h3>
                <p class="text-center">After verification you can add your Business/Post/Event/Etc.</p>
             
                    <div class="mb-3">
                        <label for="mobile" class="form-label">Mobile No</label>
                        <input 
        type="number" 
        id="mobile" 
        v-model="register.mobile" 
        class="form-control" 
        required
        maxlength="10" 
        @input="validateMobile"
    >
                    </div>

                    <div class="mb-3" v-if="isOtpSent">
                        <label for="otp" class="form-label">Otp</label>
                        <input type="number" id="otp" v-model="register.otp" class="form-control" maxlength="4">
                    </div>     
                    <div class="mb-3"  v-if="isNameRequired">
                        <label for="name" class="form-label">Name</label>
                        <input type="text" id="name" v-model="register.name" class="form-control" required>
                    </div>               

                    <button type="submit" class="btn btn-primary w-100 custom-btn" @click="newregister">Verify</button>
          
              
            </div>
        </div>

        <!-- end ---------------------------------------------------------body----------------------------------------------------------------------------->










   

         <!-- footer -->
         <div class="footer bg-white shadow mt-auto border-top">
            <div class="d-flex align-items-center justify-content-center py-1">
                <!--<p style="text-align: center; color: white; margin: 0;">Designed And Developed by DK Techno's</p>-->
            </div>
        </div>
        
      </div>
</template>
<style>
.weather-container {
  text-align: center;
    font-family: Arial, sans-serif;
    padding: 4px 20px;
    background: #f4f4f4;
    margin: auto;
    border-radius: 10px;
}
.bg_card{
  background: #ededec;
    margin: 10px 0px;
    padding-bottom: 10px;
}
.custom-btn {
    background: linear-gradient(328deg, #ff0000, #000199);
    border: none; /* Remove Bootstrap's default border */
    color: white; /* Ensure text is readable */
}

</style>

<script> 
import axios from "@/plugins/axios";  

export default {
  name: 'HomeView',
  components: { 
  },
  mounted() {
 
},
  data() {
    return {
      loading:false,
      error:null,
      register:{
        name:'',
        mobile:'',
        otp:''
      },
      isOtpSent:false,
      isNameRequired:false,
      

    }
  },
  methods:{
      validateMobile() {
    // Convert to string, remove non-numeric characters, and limit to 10 digits
    this.register.mobile = this.register.mobile.toString().slice(0, 10);
  },
    initializeHomeContent(){ 
    }
, 

      newregister() {
      

        try {
           var self=this;
           if(self.isOtpSent){
                        axios.post("verifyregistration",self.register).then((response) => {
                                // self.token=response.data.token;  
                                if(response.data.success==1){
                                  localStorage['token']=response.data.token;
                                  window.location.replace(window.location.origin+"");
                                } 
                                
                                self.$swal(response.data.message);
                               // self.$swal(response.data.smsResponse);
                                
                          
                                        
                    }).then(() => {
                        
                
                    });;
           }else{
                    axios.post("newregister",self.register).then((response) => {
                            self.isNameRequired=response.data.isNameRequired;
                            self.isOtpSent=response.data.isOtpSent;

                            self.$swal(response.data.smsResponse);

                }).then(() => {
                    
            
                });;

           }
            
         

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } 
      }, 









  }
}
</script>
